import { faFaceAwesome } from '@fortawesome/pro-solid-svg-icons'

import { TertiaryButton } from 'Components/_theme'

import { Heading } from '../Heading/Heading'

export const TertiaryButtonPresentation = () => (
  <div>
    <Heading size={4}>Tertiary Buttons:</Heading>
    <Heading size={5}>Medium: </Heading>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Medium *** */}

      <TertiaryButton size="medium">TerM Button</TertiaryButton>

      {/* *** Tertiary Button Medium icon Left *** */}

      <TertiaryButton iconLeft={faFaceAwesome} size="medium">
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium icon Right *** */}

      <TertiaryButton iconRight={faFaceAwesome} size="medium">
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium icon Both *** */}

      <TertiaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        TerM Button
      </TertiaryButton>
    </div>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Medium Disabled *** */}

      <TertiaryButton disabled size="medium">
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium Disabled icon Left *** */}

      <TertiaryButton disabled iconLeft={faFaceAwesome} size="medium">
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium Disabled icon Right *** */}

      <TertiaryButton disabled iconRight={faFaceAwesome} size="medium">
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium Disabled icon Both *** */}

      <TertiaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        TerM Button
      </TertiaryButton>
    </div>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Medium Outline *** */}

      <TertiaryButton appearance="outline" size="medium">
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium Outline icon Left *** */}

      <TertiaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        size="medium"
      >
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium Outline icon Right *** */}

      <TertiaryButton
        appearance="outline"
        iconRight={faFaceAwesome}
        size="medium"
      >
        TerM Button
      </TertiaryButton>

      {/* *** Tertiary Button Medium Outline icon Both *** */}

      <TertiaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        TerM Button
      </TertiaryButton>
    </div>
    <Heading size={5}> Large: </Heading>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Large *** */}

      <TertiaryButton size="large">TerL Button</TertiaryButton>

      {/* *** Tertiary Button Large icon Left *** */}

      <TertiaryButton iconLeft={faFaceAwesome} size="large">
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large icon Right *** */}

      <TertiaryButton iconRight={faFaceAwesome} size="large">
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large icon Both *** */}

      <TertiaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        TerL Button
      </TertiaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Large Disabled *** */}

      <TertiaryButton disabled size="large">
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large Disabled icon Left *** */}

      <TertiaryButton disabled iconLeft={faFaceAwesome} size="large">
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large Disabled icon Right *** */}

      <TertiaryButton disabled iconRight={faFaceAwesome} size="large">
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large Disabled icon Both *** */}

      <TertiaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        TerL Button
      </TertiaryButton>
    </div>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Large Outline *** */}

      <TertiaryButton appearance="outline" size="large">
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large Outline icon Left *** */}

      <TertiaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        size="large"
      >
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large Outline icon Right *** */}

      <TertiaryButton
        appearance="outline"
        iconRight={faFaceAwesome}
        size="large"
      >
        TerL Button
      </TertiaryButton>

      {/* *** Tertiary Button Large Outline icon Both *** */}

      <TertiaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        TerL Button
      </TertiaryButton>
    </div>

    <Heading size={5}> Small: </Heading>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Small *** */}

      <TertiaryButton size="small">TerS Button</TertiaryButton>

      {/* *** Tertiary Button Small icon Left *** */}

      <TertiaryButton iconLeft={faFaceAwesome} size="small">
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small icon Right *** */}

      <TertiaryButton iconRight={faFaceAwesome} size="small">
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small icon Both *** */}

      <TertiaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        TerS Button
      </TertiaryButton>
    </div>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Small Disabled *** */}

      <TertiaryButton disabled size="small">
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small Disabled icon Left *** */}

      <TertiaryButton disabled iconLeft={faFaceAwesome} size="small">
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small Disabled icon Right *** */}

      <TertiaryButton disabled iconRight={faFaceAwesome} size="small">
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small Disabled icon Both *** */}

      <TertiaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        TerS Button
      </TertiaryButton>
    </div>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Tertiary Button Small Outline *** */}

      <TertiaryButton appearance="outline" size="small">
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small Outline icon Left *** */}

      <TertiaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        size="small"
      >
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small Outline icon Right *** */}

      <TertiaryButton
        appearance="outline"
        iconRight={faFaceAwesome}
        size="small"
      >
        TerS Button
      </TertiaryButton>

      {/* *** Tertiary Button Small Outline icon Both *** */}

      <TertiaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        TerS Button
      </TertiaryButton>
    </div>
  </div>
)
